export default __webpack_public_path__ + "static/media/info_4_mobile.12db4ad4.jpg";